@let buildingsValue = buildings();
@if (buildingsValue && buildingsValue.length > 0) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix()"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ translationKey('appendices.title') | translate }}</h1>
    <p>
      {{ translationKey('appendices.body') | translate }}
    </p>
  </cfp-report-page>
  @for (building of buildingsValue; track building.building.id; let lastBuilding = $last) {
    <cfp-report-roadmap-building-page
      [building]="building"
      [customerName]="customerName()"
      [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmap()"
      [translationKeyPrefix]="translationKeyPrefix()"
      [showEnergyLabelHistory]="showEnergyLabelHistory()"
      [headerLogo]="headerLogo()"
      [chromeFooter]="chromeFooter()"
      [trailingContent]="buildingExtraPage()"
      [trailingContentHeight]="buildingExtraPageHeight()"
      [endsReport]="endsReport() && lastBuilding"
    />
  }
}
